import { createReducer } from "typesafe-actions";

import { Actions, fetchRoutes } from "./actions";
import RouteState from "./RouteState";

const initialState: RouteState = {
  loading: false,
  routes: [],
};

const routes = createReducer<RouteState, Actions>(initialState)
  .handleAction(fetchRoutes.request, (state) => ({
    ...state,
    loading: true,
  }))
  .handleAction(fetchRoutes.success, (state, action) => ({
    ...state,
    loading: false,
    routes: action.payload,
  }))
  .handleAction(fetchRoutes.failure, (state) => ({
    ...state,
    loading: false,
  }));

export type RoutesActions = Actions;
export default routes;
